import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useUserStore } from 'stores';
// icons
import { 
  FaUserAlt, 
  FaSignInAlt, 
  FaHeart, 
  FaUserEdit, 
  FaSignOutAlt, 
  FaBookReader, 
  FaShoppingBag,
  FaChartBar,
  FaFileInvoice
} from 'react-icons/fa';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// components
import DropMenuLogged from 'components/navbar/DropMenuLogged';

const MyAccount = ({ setShowOffCanvas, closeSession, isDesktop = false, isSticky }) => {
  const { t } = useTranslation(['header']);
  const { isLogged, isSpecialConcourseUser } = useUserStore();
  const { libraryPath } = useAssignedLibrary();

  const getMyAccount = () => (isLogged ?
    isDesktop ? (<div className="header__button--logged">
      <DropMenuLogged
        className="header__button "
        dropDirection="down"
        closeSession={closeSession}
        sticky={isSticky}
      />
    </div>) : (<>
      <Link className="hamb-menu-user" to={libraryPath('perfil')} onClick={() => setShowOffCanvas(false)} >
        <FaUserEdit className="icon-sm fas ham-h i-user" title="Mi Perfil" />
        <span className="simple-hide-mobile">{t("myProfile")}</span>
      </Link>
      <Link className="hamb-menu-user" to={libraryPath('mis-libros')} onClick={() => setShowOffCanvas(false)} >
        <FaBookReader className="icon-sm fas ham-h i-user" title="Mis Libros" />
        <span className="simple-hide-mobile">{t("myBooks")}</span>
      </Link>
      <Link className="hamb-menu-user" to={libraryPath('favoritos')} onClick={() => setShowOffCanvas(false)} >
        <FaHeart className="icon-sm fas ham-h i-user" title="Mis Favoritos" />
        <span className="simple-hide-mobile">{t("misFavoritos")}</span>
      </Link>
      <Link className="hamb-menu-user" to={libraryPath('order-list')} onClick={() => setShowOffCanvas(false)} >
        <FaShoppingBag className="icon-sm fas ham-h i-user" title="Mis Pedidos" />
        <span className="simple-hide-mobile">{t("myOrders")}</span>
      </Link>
      {isSpecialConcourseUser && (
        <>
          <Link className="hamb-menu-user" to={libraryPath('order-controls')} onClick={() => setShowOffCanvas(false)} >
            <FaChartBar className="icon-sm fas ham-h i-user" title={t("orderControl")} />
            <span className="simple-hide-mobile">{t("orderControl")}</span>
          </Link>
          <Link className="hamb-menu-user" to={libraryPath('mis-pedidos')} onClick={() => setShowOffCanvas(false)} >
            <FaFileInvoice className="icon-sm fas ham-h i-user" title={t("albaranesYFacturas")} />
            <span className="simple-hide-mobile">{t("albaranesYFacturas")}</span>
          </Link>
        </>
      )}
      <button
        type="button"
        className="hamb-menu-user border-0 bg-transparent w-100 text-start"
        onClick={() => closeSession()}
      >
        <FaSignOutAlt className="icon-sm fas ham-h i-user" title="Cerrar sesión" />
        <span className="simple-hide-mobile">{t("logout")}</span>
      </button>
    </>) : (<>
      <Link to={libraryPath('registro')}
        className={`${isDesktop ? `navbar-right__link position-relative pt-0 ${isSticky ? 'navbar-item-log' : ''}` : 'hamb-menu-user'}`}
        onClick={() => setShowOffCanvas && setShowOffCanvas(false)}>
        <FaUserAlt className={`${isDesktop ? 'fas i-user' : 'icon-sm fas ham-h sign-in-alt'}`} title="Registro" />
        <span className={`${isDesktop ? `simple-hide-desktop ${isSticky ? 'd-none' : 'd-block'}` : 'simple-hide-mobile'}`}>{t('registro')}</span>
      </Link>
      <Link to={libraryPath('inicio-sesion')}
        className={`${isDesktop ? `navbar-right__link position-relative pt-0 ${isSticky ? 'navbar-item-log' : ''}` : 'hamb-menu-user'}`}
        onClick={() => setShowOffCanvas && setShowOffCanvas(false)}>
        <FaSignInAlt className={`${isDesktop ? 'fas sign-in-alt' : 'icon-sm fas ham-h sign-in-alt'}`} title="Iniciar sesión" />
        <span className={`${isDesktop ? `simple-hide-desktop ${isSticky ? 'd-none' : 'd-block'}` : 'simple-hide-mobile'}`}>{t('iniciarSesion')}</span>
      </Link>
    </>))

  return (
    <>
      {isDesktop ? getMyAccount() : <div className="hamb-menu d-lg-none">
        {/* CONEXION DESDE MENU HAMBURGUESA*/}
        {getMyAccount()}
      </div>}
    </>
  );
};

MyAccount.propTypes = {
  setShowOffCanvas: PropTypes.func,
  closeSession: PropTypes.func,
  isDesktop: PropTypes.bool,
  isSticky: PropTypes.bool
};

export default MyAccount;
